import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { IEmployee } from '@widgets/EstimateInformation/model/types/types';
import { AddInput } from '@widgets/EstimateInformation/ui/modals/AddUsersModal/AddEmployeeInput/AddInput';
import { ExistInput } from '@widgets/EstimateInformation/ui/modals/AddUsersModal/AddEmployeeInput/ExistInput';

interface AddEmployeeInputProps {
    modalMode?: 'managers' | 'purchasers' | null;
    inputMode?: 'add' | 'exist' | null;
    employees?: IEmployee[];
    onChangeInputMode?: (value: 'add' | 'exist' | null) => void;
    onSetAddingUserEmail?: (value: string | null) => void;
}

export const AddEmployeeInput = ({
    inputMode,
    employees,
    onChangeInputMode,
    modalMode,
    onSetAddingUserEmail,
}: AddEmployeeInputProps) => {
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const [error, setError] = useState<string | null>(null);

    const onSetEmailError = (): void => {
        setError(t('AddEmployeeInput.onSetEmailError.setError'));
    };

    const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (error) setError(null);
        setValue(e.target.value);
    };

    const inputMapping = {
        add: (
            <AddInput
                error={error}
                onSetAddingUserEmail={onSetAddingUserEmail}
                modalMode={modalMode}
                employees={employees}
                onChangeInputMode={onChangeInputMode}
                value={value}
                onInput={onInput}
                onSetEmailError={onSetEmailError}
            />
        ),
        exist: (
            <ExistInput
                onSetAddingUserEmail={onSetAddingUserEmail}
                modalMode={modalMode}
                onChangeInputMode={onChangeInputMode}
                value={value}
                onInput={onInput}
                onSetEmailError={onSetEmailError}
                error={error}
            />
        ),
    };

    return inputMapping[inputMode];
};
